// AppPaths.ts
import {generatePathSafe} from "@/lib/utils";

export const AppPaths = {
    LANDING_PAGE: "/",
    IMPRESSUM_PAGE: "/impressum",
    PRIVACY_PAGE: "/privacy",
    COOKIE_POLICY_PAGE: "/cookie-policy",
    SIGN_IN: "/sign-in",

    COMPANY_SIGNUP: "/company-signup/:token",
    COMPANY_SIGNUP_fn: (token: string) => generatePathSafe(AppPaths.COMPANY_SIGNUP, {token}),

    COMPANY_OVERVIEW: "/company-overview",
    COMPANY_UNVERIFIED: "/company-unverified",
    COMPANY: "/company/:id",
    COMPANY_fn: (id: number) => generatePathSafe(AppPaths.COMPANY, {id}),
    SETTINGS_COMPANIES: "/settings/companies",

    CARTON_GRADES: "/carton-grades",

    USER_SIGNUP: "/user-signup/:token",
    CONFIRM_COMPANY: "/confirm-company/:token",
    USER_PASSWORD_RESET: "/user-password-reset/:token",
    USER_PASSWORD_RESET_REQUEST: "/user-password-reset-request",
    USER: "/user/:id",
    USER_fn: (id: number, companyId?: number) => {
        const path = generatePathSafe(AppPaths.USER, {id});
        return companyId ? `${path}?companyId=${companyId}` : path;
    },

    EXTERNAL_REQUEST_OVERVIEW: "/external-request-overview",
    EXTERNAL_REQUEST: "/external-request/:id",
    EXTERNAL_REQUEST_fn: (id: number) => generatePathSafe(AppPaths.EXTERNAL_REQUEST, {id}),

    OPERATOR_REQUEST_OVERVIEW: "/operator-request-overview",

    INTERNAL_REQUEST_OVERVIEW: "/internal-request-overview",
    INTERNAL_REQUEST: "/internal-request/:id?",
    INTERNAL_REQUEST_fn: (id: number | "create" | "clone", cloneId?: number) => {
        const route = generatePathSafe(AppPaths.INTERNAL_REQUEST, {id});
        if (id === "clone") {
            return `${route}?sourceId=${cloneId}`;
        }
        return route;
    },

    ADMIN_ADDRESSES: "/admin/addresses",
    LANGUAGE_FILES: "/language-files",

    INTERNAL_ORDER_TRACKING: "/order-tracking/internal",
    EXTERNAL_ORDER_TRACKING: "/order-tracking/external",

    BIDDER_OVERVIEW: "/bidder-overview",
    REQUESTER_OVERVIEW: "/requester-overview",

    ADMIN_REPORTS: "/admin/reports"
};
